import React from 'react';
import FlowRendererField from 'conversie-flow-bundle/assets/js/components/flow/renderers/FlowRendererField';

/* Conversion Fields */
import ConversionFieldChoiceVwpfs from '../fields/ConversionFieldChoiceVwpfs';
import ConversionFieldSelectVwpfs from '../fields/ConversionFieldSelectVwpfs'

export default function ConversionComponentLeaseCalculator({ component, path, id, summary, ...passProps }) {
    return (
        <>
            <FlowRendererField
                component={component}
                fields={component?.fields}
                path={`${path}.fields`}
                id={`${id}.fields`}
                {...passProps}
                renderField={(field, props) => {
                    if (field?.view === 'expanded' && field.type === 'choice-radio') {
                        return (
                            <ConversionFieldChoiceVwpfs
                                {...props}
                                customControlClassName={`custom-control--${field.view}`}
                                choiceColClassName={field.view === 'choice' ? 'col' : props?.colClassName}
                                colClassName="col-12"
                                inputType="radio"
                            />
                        );
                    }

                    if (field.type === 'choice-dropdown' && field.view === 'expanded') {
                        return (
                            <ConversionFieldSelectVwpfs
                                {...props}
                                inputType="select"
                            />

                        )
                    }
                }}
            />
        </>
    );
}
